// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styles-module_root_sAAInP{max-width:500px;padding-top:20px}", "",{"version":3,"sources":["webpack://./avail-web-ui/src/components/Notification/styles.module.scss"],"names":[],"mappings":"AAAA,2BACE,eAAA,CACA,gBAAA","sourcesContent":[".root {\n  max-width: 500px;\n  padding-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "styles-module_root_sAAInP"
};
export default ___CSS_LOADER_EXPORT___;
